import { render } from "./EmbedProjectsView.vue?vue&type=template&id=baac596a"
import script from "./EmbedProjectsView.vue?vue&type=script&lang=js"
export * from "./EmbedProjectsView.vue?vue&type=script&lang=js"

import "./EmbedProjectsView.vue?vue&type=style&index=0&id=baac596a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__